var React = require('react');

function IcoList (props) {
    return React.createElement("svg",props,[React.createElement("polygon",{"points":"1.6,11.2 9.3,11.2 9.3,3.5 1.6,3.5 \t","key":0}),React.createElement("polygon",{"points":"15.1,11.2 35.8,11.2 35.8,3.5 15.1,3.5 \t","key":1}),React.createElement("polygon",{"points":"1.6,22.7 9.3,22.7 9.3,15.2 1.6,15.2 \t","key":2}),React.createElement("polygon",{"points":"15.1,22.7 35.8,22.7 35.8,15.2 15.1,15.2 \t","key":3}),React.createElement("polygon",{"points":"1.6,34.4 9.3,34.4 9.3,26.8 1.6,26.8 \t","key":4}),React.createElement("polygon",{"points":"15.1,34.4 35.8,34.4 35.8,26.8 15.1,26.8 \t","key":5})]);
}

IcoList.defaultProps = {"viewBox":"0 0 38 38","id":"listic","className":"bst0"};

module.exports = IcoList;

IcoList.default = IcoList;
